<template>
	<div class="text-center">
		<v-menu offset-y>
			<template v-slot:activator="{ on, attrs }">
				<v-btn class="create-group-btn" color="primary" dark v-bind="attrs" v-on="on"> Create Group </v-btn>
			</template>
			<v-list class="group-menu-list">
				<v-list-item v-for="(item, index) in items" :key="index">
					<MaybeUpgradeRequiredIndicator :billingFeatureId="item.billingFeatureId">
						<template #default="{ indicator, isUpgradeRequired }">
							<v-list-item-title @click="menuActionClick(item, isUpgradeRequired, indicator, item.billingFeatureId)">
								<CreateGroupButtonItem :item="item" :indicator="indicator" :isUpgradeRequired="isUpgradeRequired" />
							</v-list-item-title>
						</template>
					</MaybeUpgradeRequiredIndicator>
				</v-list-item>
			</v-list>
		</v-menu>
	</div>
</template>

<script>
import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator';
import CreateGroupButtonItem from '@/components/Settings/groups/CreateGroupButtonItem';
export default {
	name: 'CreateGroupButton',
	components: { MaybeUpgradeRequiredIndicator, CreateGroupButtonItem },
	props: {
		items: { type: Array },
	},
	watch: {},
	methods: {
		menuActionClick(item, isUpgradeRequired, indicator, billingFeatureId) {
			if (isUpgradeRequired) {
				return indicator.setup().openUpgrade(null, billingFeatureId);
			}
			item.onClick();
		},
	},
	mounted() {},
	data: () => ({}),
};
</script>

<style scoped lang="scss">
.create-group-btn {
	width: 195px;
}
.sub-title {
	font-size: small;
	color: grey;
}
.group-menu-list {
	cursor: pointer;
}
</style>
